// extracted by mini-css-extract-plugin
export var wrapper = "b_b";
export var box = "b_c";
export var cta = "b_d";
export var actions = "b_f";
export var headerWrapper = "b_g";
export var header = "b_h";
export var fixed = "b_j";